"use client";

import { createContext, useContext } from "react";

export interface ChatJsonRenderContextValue {
  chatId?: string;
  streamLoading?: boolean;
  collapsed?: boolean;
  metrics?: string;
  notificationId?: string;
  messageId?: string;
}

const ChatJsonRenderContext = createContext<ChatJsonRenderContextValue | null>(
  null,
);

interface ChatJsonRenderContextProviderProps {
  value?: ChatJsonRenderContextValue;
  children: React.ReactNode;
}

export const ChatJsonRenderContextProvider: React.FC<
  ChatJsonRenderContextProviderProps
> = ({ value, children }) => (
  <ChatJsonRenderContext.Provider value={value ?? null}>
    {children}
  </ChatJsonRenderContext.Provider>
);

export const useChatJsonRenderContext = () => useContext(ChatJsonRenderContext);
